import { type RouteObject, Navigate } from 'react-router';
import { useNavigate } from 'react-router';
import { HomePage } from '@/pages/HomePage';
import { JoinPage } from '@/pages/JoinPage';
import { CreateRoomPage } from '@/pages/CreateRoomPage';
import { RoomPage } from '@/pages/RoomPage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { SplashPage } from '@/pages/SplashPage';
import { AppShell } from '@/components/shell/AppShell';

export const SPLASH_SEEN_KEY = 'splashSeen';

function SplashRoute() {
  const navigate = useNavigate();
  const handleEnter = () => {
    sessionStorage.setItem(SPLASH_SEEN_KEY, '1');
    void navigate('/');
  };
  return <SplashPage onEnter={handleEnter} />;
}

// Редирект на /splash решается здесь, внутри роутера, а не через
// history.replaceState до монтирования React (R01): raw History API не
// бьёт popstate, и на широких экранах роутер успевал замэтчить "/" по
// исходному URL раньше, чем main.tsx подменял адресную строку — в адресной
// строке оставался /splash, а рендерился HomePage.
export function HomeRoute() {
  if (!sessionStorage.getItem(SPLASH_SEEN_KEY)) {
    return <Navigate to="/splash" replace />;
  }
  return <HomePage />;
}

export const routes: RouteObject[] = [
  { path: '/splash', element: <SplashRoute /> },
  {
    element: <AppShell />,
    children: [
      { path: '/', element: <HomeRoute /> },
      { path: '/join', element: <JoinPage /> },
      { path: '/create', element: <CreateRoomPage /> },
      { path: '/r/:code', element: <RoomPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
];
